import { render, staticRenderFns } from "./paymentpage.vue?vue&type=template&id=065267fa&scoped=true"
import script from "./paymentpage.vue?vue&type=script&lang=js"
export * from "./paymentpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065267fa",
  null
  
)

export default component.exports